import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ progress, message, showPercentage = true, variant = 'linear', current, total }) => {
  if (variant === 'circular') {
    const radius = 50;
    const stroke = 6;
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (Math.min(100, Math.max(0, progress)) / 100) * circumference;

    return (
      <div className="progress-overlay">
        <div className="circular-progress-box">
          <div className="circular-progress-container">
            <svg
              height={radius * 2}
              width={radius * 2}
              className="circular-progress-svg"
            >
              <circle
                stroke="#eee"
                strokeWidth={stroke}
                fill="transparent"
                r={normalizedRadius}
                cx={radius}
                cy={radius}
              />
              <circle
                stroke="#28a745"
                fill="transparent"
                strokeWidth={stroke}
                strokeDasharray={circumference + ' ' + circumference}
                style={{ strokeDashoffset, transition: 'stroke-dashoffset 0.5s ease-in-out' }}
                strokeLinecap="round"
                r={normalizedRadius}
                cx={radius}
                cy={radius}
                className="progress-circle-fill"
              />
            </svg>
            <div className="circular-progress-text">
              <div className="percentage">{Math.round(progress)}%</div>
              {(current !== undefined && total !== undefined) && (
                <div className="count-text">{current} / {total}</div>
              )}
            </div>
          </div>
          {message && <div className="progress-message-circular">{message}</div>}
        </div>
      </div>
    );
  }

  return (
    <div className="progress-container">
      {message && <div className="progress-message">{message}</div>}
      <div className="progress-bar-wrapper">
        <div
          className="progress-bar-fill"
          style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
        />
      </div>
      {showPercentage && (
        <div className="progress-percentage">{Math.round(progress)}%</div>
      )}
    </div>
  );
};

export default ProgressBar;

